import BaseView from './utilities/baseView.js';

class CmsView extends BaseView {

    constructor() {
        super(cmsConfig, false, cmsConfig.disableCookieModal);
    }
}

new CmsView();